import { render } from "./PaginationDiv.vue?vue&type=template&id=cf79386c&scoped=true"
import script from "./PaginationDiv.vue?vue&type=script&lang=js"
export * from "./PaginationDiv.vue?vue&type=script&lang=js"

import "./PaginationDiv.vue?vue&type=style&index=0&id=cf79386c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf79386c"]])

export default __exports__